module.exports = __webpack_public_path__ + "static/media/image26.cd366314.JPG";